var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('input',{staticStyle:{"width":"100px","height":"50px","background":"#333"},attrs:{"type":"file"}})])
}]

export { render, staticRenderFns }